"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValSummary = void 0;
var template = "<ul>\n        <li v-for=\"error in errors\" :key=\"error\" class=\"text-danger\">\n            {{ error }}\n        </li>\n    </ul>";
var vue_1 = require("vue");
/**
 * A validation summary that displays each validation message in an unordered list with the text-danger class
 */
exports.ValSummary = (0, vue_1.defineComponent)({
    name: "val-summary",
    template: template,
    props: {
        /** an array of validation error messages */
        errors: {
            default: function () { return []; },
            type: Array,
            required: true
        }
    }
});
//# sourceMappingURL=ValSummary.js.map